var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v("입금하실 계좌")])]), _c('vertical-form-table', _vm._b({
    attrs: {
      "value": _vm.form,
      "mode": "view"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }